import { GlAlert, GlSprintf } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import SecretsCount from '../../../../../ee/app/assets/javascripts/delete_modal/components/delete_modal_secrets_count.vue?vue3';
import { numberToMetricPrefix } from '~/lib/utils/number_utils';
import GroupsProjectsDeleteModal from '../../groups_projects/components/delete_modal.vue?vue3';
import { RESOURCE_TYPES } from '~/groups_projects/constants';
import { InternalEvents } from '../../tracking/index.js?vue3';
export default {
    name: 'GroupDeleteModal',
    RESOURCE_TYPES,
    components: {
        GroupsProjectsDeleteModal,
        GlAlert,
        GlSprintf,
        SecretsCount
    },
    mixins: [
        InternalEvents.mixin()
    ],
    inject: [
        'triggerDeleteLocation'
    ],
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        confirmPhrase: {
            type: String,
            required: true
        },
        fullName: {
            type: String,
            required: true
        },
        confirmLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        subgroupsCount: {
            type: Number,
            required: false,
            default: null
        },
        projectsCount: {
            type: Number,
            required: false,
            default: null
        },
        markedForDeletion: {
            type: Boolean,
            required: true
        },
        permanentDeletionDate: {
            type: String,
            required: true
        }
    },
    emits: [
        'primary',
        'change'
    ],
    data () {
        return {
            showSecretsCountFetchError: false
        };
    },
    methods: {
        numberToMetricPrefix,
        handlePrimary () {
            this.trackEvent('trigger_delete_on_group', {
                label: this.triggerDeleteLocation,
                property: String(this.markedForDeletion),
                actor: 'user'
            });
            this.$emit('primary');
        }
    }
};
